<!-- Navbar -->
<div *ngIf="isCoreAccess()" class="sub-header">
  <div class="container" style="height: 100%;">
    <div class="controls-panel">

      <div class="btn-rbv-dropdown pull-right" dropdown style="width: auto;">
        <button dropdownToggle class="btn btn-rbv" type="button">
          {{selectedQueryType.NAME}} <i class="fa fa-chevron-down"></i>
        </button>

        <div *dropdownMenu class="drop-menu dropdown-menu-left rounded-0" style="width: 200px;">
          <a class="drop-item" *ngFor="let type of queryTypes" (click)="selectQueryType(type)">
            <div class="item">{{type.NAME}}</div>
          </a>
        </div>
      </div>

      <input-search placeholder="Search by {{selectedQueryType.NAME}}" (searchTriggered)="searchReport($event)"
        [no-drop-icon]="true"></input-search>
      <button type="button" class="btn btn-rbv pull-right" (click)="createNewReport()"
        *ngIf="reports?.length>0 && queryString?.length === 0">
        New Report
      </button>
    </div>
  </div>
</div>

<!-- Loader -->
<dashboard-loader [loading]="isLoading"></dashboard-loader>

<!-- Page Container -->
<ng-container *ngIf="isCoreAccess();else NonCoreUser">
  <div class="container" [hidden]="isLoading">
    <div class="dashboard">
      <div class="wrapper">
        <!-- Header with Filter and Sorting -->
        <div>
          <app-dashboard-filter [page]="currentPage" [stages]="stages" [states]="states"
            [reportsLoading]="reportsLoading" (filterChanged)="onFilterValueChanged($event)"
            (onChangeValue)="onChangeValue($event)" (onDelete)="onDeleteMultiple($event)">

          </app-dashboard-filter>
        </div>
        <!-- Create New Report When list is empty -->
        <div *ngIf="reports?.length == 0 && queryString?.length === 0 && !isLoading"
          style="text-align: center;padding: 60px;">
          <h4 style="margin-bottom: 20px;">You don't have any Reports yet</h4>
          <button type="button" class="btn btn-rbv" (click)="createNewReport()">Create New Report</button>
        </div>

        <!-- No Reports Found -->
        <div *ngIf="reports?.length == 0 && queryString?.length > 0" style="text-align: center;padding: 60px;">
          <h4 style="margin-bottom: 20px;">No Reports Found for Search criteria</h4>
        </div>

        <!-- Loader -->
        <!-- <loader [loading]="isLoading"></loader> -->
        <crm-alert #alert></crm-alert>

        <!-- New Reports Table -->
        <div class="new-reports mt-4" *ngIf="reports?.length > 0 && !isLoading">
          <report-row *ngFor="let report of reports; let i = index" [report]="report" [tags]="tags"
            [rowStyle]="rowStyle" (reportDeleted)="reportDeleted($event)"
            (filterTagChanged)="onFilterTagChanged($event)" (quoteUpdated)="loadReports(1)" (reportUpdated)="loadReports(1)"
            [isLast]="i === reports.length - 1"></report-row>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div style="width:100%;text-align:right;" class="pagination-wrapper" *ngIf="!isHistoryReports">
      <select class="page-size custom-select rounded-0" [(ngModel)]="currentSize"
        (change)="sizeChange($event.target.value)">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="25">25</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>

      <pagination [totalItems]="totalItems" [itemsPerPage]="currentSize" [(ngModel)]="currentPage" [maxSize]="5"
        [boundaryLinks]="true" [rotate]="false" (pageChanged)="pageChanged($event)" class="pagination-sm"></pagination>
    </div>

    <div class="pagination-size" *ngIf="!isLoading">Total of {{totalItems}} records in this list</div>
  </div>
</ng-container>

<ng-template #NonCoreUser>
  <ng-container *ngIf="isDataEntryRole();else Empty">
    <div class="container">
      <section class="dashboard_tiles">
        <a class="dashboard_items" [routerLink]="['/manage/research/ibis']" routerLinkActive="active">
          <img alt="Reliant Business Valuation" src="/assets/images/header-logo.png">
          <label>IBIS Databases</label>
        </a>
        <a class="dashboard_items" [routerLink]="['/manage/research/pnc']" routerLinkActive="active">
          <img alt="Reliant Business Valuation" src="/assets/images/header-logo.png">
          <label>PNC Reports</label>
        </a>
      </section>
    </div>
  </ng-container>
</ng-template>

<ng-template #Empty> </ng-template>



<!-- Modal to export -->
<ng-template #PageExport>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Export</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <page-report-export></page-report-export>
  </div>
  <div class="modal-footer">
    <button class="btn btn-rbv default" (click)="closeModal()">
      Cancel
    </button>
  </div>
</ng-template>